import { makeStyles, withStyles } from '@material-ui/core';
import { Rating } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  input: {
    '& label': {
      transform: 'translate(0, 1.5px)',
      width: '100%',
      '& .label--required': {
        color: theme.palette.primary.main,
      },
      '& .label--icon-valid': {
        color: theme.palette.primary.main,
      },
    },
  },
  starsContainer: {
    marginTop: '2rem',
  },
}));

const StyledRating = withStyles({
  root: {
    gap: '4px',
  },
  label: {
    fontSize: '2.2rem',
  },
  iconFilled: {
    color: '#88c827',
  },
  iconHover: {
    color: '#88c827',
  },
})(Rating);

export { StyledRating, useStyles };
